import styled from 'styled-components';
import lightTheme from 'themes/lightTheme';
import { RAIL_WIDTH } from './NavLayout.styled';

const brand = lightTheme.colors.primary;
const fontPrimary = lightTheme.fonts.primary;

export const Rail = styled.nav`
  width: ${RAIL_WIDTH}px;
  height: 100vh;
  background: ${brand};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0 20px;
  flex-shrink: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  box-shadow: 2px 0 20px rgba(0, 0, 0, 0.3);
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.35);
  }
`;

export const RailLogoWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 6px;
  cursor: pointer;
`;

export const RailLogoBox = styled.div`
  width: 52px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 150ms ease-in-out;
  position: relative;

  &:hover {
    transform: scale(1.08);
  }
`;

export const RailLogo = styled.img`
  width: 41px;
  height: 41px;
  object-fit: contain;
`;

export const RailLogoDivider = styled.div`
  width: 32px;
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin-top: 2px;
`;

export const RailSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  width: 100%;
  padding: 6px 0;
`;

export const RailItem = styled.div`
  width: 52px;
  height: 52px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.65);
  cursor: pointer;
  transition: all 150ms ease-in-out;
  position: relative;
  gap: 4px;
  user-select: none;
  flex-shrink: 0;

  &:hover {
    background: ${(props) =>
      props.isActive ? '#0f0f23' : 'rgba(255, 255, 255, 0.12)'};
    color: white;
  }
  &:hover .rail-label {
    opacity: 1;
  }

  ${(props) =>
    props.isActive &&
    `
    background: #0f0f23;
    color: white;
    box-shadow: 0 2px 8px rgba(0,0,0,0.4), inset 0 0 0 1px rgba(255,255,255,0.08);
  `}

  /* Arrow indicator pointing to panel when open */
  &::after {
    content: '';
    position: absolute;
    right: -6px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 8px solid #0f0f23;
    z-index: 11;
    transition: opacity 150ms ease-in-out;
    opacity: ${(props) => (props.isActive && props.showArrow ? 1 : 0)};
    pointer-events: none;
  }
`;

export const RailIcon = styled.svg`
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.4;
  stroke-linecap: round;
  stroke-linejoin: round;
`;

export const RailLabel = styled.span`
  font-family: ${fontPrimary};
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.2px;
  opacity: ${(props) => (props.isActive ? 1 : 0.8)};
  white-space: nowrap;
`;

export const NotifBadge = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 18px;
  height: 16px;
  background: white;
  color: ${brand};
  border-radius: 8px;
  font-size: 9px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
`;

export const RailSpacer = styled.div`
  flex: 1;
  min-height: 16px;
`;

export const RailAvatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: white;
  cursor: pointer;
  transition: all 150ms ease-in-out;
  margin-top: 12px;
  margin-bottom: 4px;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
  }
`;
